var text_field_default = {
  "root": "-H-tm",
  "text": "wRPM3",
  "input": "x-8r-",
  "small": "-hUp6",
  "medium": "KdQ9D",
  "large": "nViqW",
  "webview": "hkGf1",
  "endAdornment": "Yp1S-",
  "shown": "_5NM8p",
  "value": "RXbjM",
  "spinner": "L-nle",
  "spin": "EYoP5"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
